// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"d0eeac7a","453":"37ab6af1","915":"fa2e2ef7"}[chunkId] + ".chunk.js";
};